<template>
  <section class="page-dashbord-mycourses pt-5">
    <app-loading :isFull="true" v-if="isLoading"/>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <header class="mb-3">
            <h2 class="font-18 text-right">لیست دوره های من</h2>
          </header>
          <b-card no-body class="mb-5">
            <b-tabs card>
              <b-tab title="دوره هایی که مخاطب آن هستم" @click="getMyEnroll">
                <m-my-enroll :items="enrollList"/>
              </b-tab>
              <b-tab v-if="isAccess" title="دوره هایی که مدرس آن هستم" @click="getMyCourse">
                <m-my-course :items="teachingList"/>
              </b-tab>
            </b-tabs>
          </b-card>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import MMyEnroll from 'cp/dashboard-component/courses/my-enroll'
import MMyCourse from 'cp/dashboard-component/courses/my-course'
export default {
  name: "page-dashbord-mycourses",
  components: {
    MMyEnroll,
    MMyCourse
  },
  data() {
    return {
      isLoading: true,
      isAccess: false
    };
  },
  mounted() {
    this.getMyEnroll();
    this.check();
  },
  computed: {
    teachingList() {
      return this.$store.state.dashboardmyCourses.teachingList
    },
    enrollList() {
      return this.$store.state.dashboardmyCourses.enrollList
    },
  },
  methods: {
    async check() {
      this.isAccess = this.checkAccess(false);
      this.isLoading = false;
    },
    getForEdit(item, index) {
      sessionStorage.setItem("course_id", item.id);
      this.$router.push("new-course");
    },
    async getMyCourse() {
      this.isLoading = true;
      await this.$store.dispatch("dashboardmyCourses/getMyCourse");
      this.isLoading = false;
    },
    async getMyEnroll() {
      this.isLoading = true;
      await this.$store.dispatch("dashboardmyCourses/getMyEnroll");
      this.isLoading = false;
    }
  }
};
</script>

<style lang="less">
@import (reference) "../../assets/css/variable.less";
.page-dashbord-mycourses {
  .box-clear;
}
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/mycourses.vue